import * as Sentry from "@sentry/react";

const DSN = import.meta.env["VITE_SENTRY_DSN"] as string | undefined;
const RELEASE = import.meta.env["VITE_SENTRY_RELEASE"] as string | undefined;
const ENVIRONMENT =
  (import.meta.env["VITE_SENTRY_ENVIRONMENT"] as string | undefined) ??
  (import.meta.env.PROD ? "production" : "development");

export function installSentry() {
  if (!DSN) return;
  Sentry.init({
    dsn: DSN,
    release: RELEASE,
    environment: ENVIRONMENT,
    tracesSampleRate: 0,
    sendDefaultPii: false,
  });
}

export { Sentry };
